import type { ApolloCache, StoreObject } from '@apollo/client';

/**
 * Prepend a newly-created draft to the cached `getDrafts` list. The draft object
 * (from the addPostDraft mutation response) is written into the normalized cache
 * and its reference is inserted at the head of the list field.
 */
export function prependDraftToCache(
  cache: ApolloCache<unknown>,
  newDraft: StoreObject,
): void {
  cache.modify({
    fields: {
      getDrafts(existing, { toReference }) {
        const list = Array.isArray(existing) ? existing : [];
        const ref = toReference(newDraft, true);
        return ref ? [ref, ...list] : list;
      },
    },
  });
}

/** Evict a deleted draft entity from the cache; gc prunes the dangling list ref. */
export function evictDraftFromCache(
  cache: ApolloCache<unknown>,
  draftId: string,
): void {
  cache.evict({
    id: cache.identify({ __typename: 'PostDraft', id: draftId }),
  });
  cache.gc();
}
